import React from 'react'

function Info() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal">
  <p className="headline-lg">Este proyecto tiene lugar bajo el marco normativo dispuestos por IDERA
(Infraestructura de Datos Espaciales de la República Argentina), basado en las normas
ISO 19100, definidas por el ISO/TC211 referidas a la información geográfica.</p>
  </div>
</div>

  )
}

export default Info